import React from "react";
import { Navigate } from "react-router-dom";

// Auth
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// Reform Pages
import ReformDashboard from "../pages/reform-Dashboard";
import ReformProductList from "../pages/reform-Products/ProductList";
import ReformProductAdd from "../pages/reform-Products/ProductAdd";
import ReformProductDetail from "../pages/reform-Products/ProductDetail";
import ReformInvoiceList from "../pages/reform-Invoices/InvoiceList";
import ReformInvoiceDetail from "../pages/reform-Invoices/InvoiceDetail";
import ReformInvoiceView from "../pages/reform-Invoices/InvoiceView";
import CustomerList from "../pages/reform-Customers/CustomerList";
import ReformCalendarPage from "../pages/reform-Calendar";
import CategoryManagement from "../pages/reform-Category";
import PersonelyManagement from "../pages/reform-Personel";
import ReformCustomerDetail from "../pages/reform-Customers/CustomerDetail";
import ProfilePage from "../pages/reform-profile";
import AddCustomer from "../pages/reform-Customers/CustomerAdd";

const authProtectedRoutes = [
  // Dashboard
  { path: "/reform-dashboard", component: <ReformDashboard /> },

  // Calendar
  { path: "/reform-calendar", component: <ReformCalendarPage /> },

  // Profile
  { path: "/reform-profile", component: <ProfilePage /> },

  // Customers
  { path: "/reform-customers/list", component: <CustomerList /> },
  { path: "/reform-customers/detail/:id", component: <ReformCustomerDetail /> },
  { path: "/reform-customers/add", component: <AddCustomer /> },

  // Products
  { path: "/reform-products/list", component: <ReformProductList /> },
  { path: "/reform-products/add", component: <ReformProductAdd /> },
  { path: "/reform-products/detail/:id", component: <ReformProductDetail /> },

  // Categories & Personnel
  { path: "/reform-categories", component: <CategoryManagement /> },
  { path: "/reform-personel", component: <PersonelyManagement /> },

  // Invoices
  { path: "/reform-invoices/list", component: <ReformInvoiceList /> },
  { path: "/reform-invoices/detail/:id?", component: <ReformInvoiceDetail /> },
  { path: "/reform-invoices/view/:id", component: <ReformInvoiceView /> },

  // Default Routes
  { path: "*", component: <Navigate to="/login" /> },
];

const publicRoutes = [
  // Authentication Routes - Only login/logout kept
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/", exact: true, component: <Navigate to="/login" /> },
];

export { authProtectedRoutes, publicRoutes };